import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { AddressBookComponent, AddressBookComponentService } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CartService } from '../../commonComponents/cart/cart.service';

@Component({
  selector: 'cx-address-book',
  templateUrl: './address-book.component.html',
  styleUrls: ['./address-book.component.scss'],
})
export class EkAddressBookComponent
  extends AddressBookComponent
  implements OnInit {
  public addressObj: any;
  addressId$: any;
  privacyPath: any;
  constructor(
    public service: AddressBookComponentService,
    protected translation: TranslationService,
    private cartService: CartService,
    private cdf: ChangeDetectorRef,
    private userAccount: UserAccountFacade,
    private globalMessageService: GlobalMessageService,
  ) {
    super(service, translation);
  }

  ngOnInit(): void {
    let path = window.location.pathname.split('/');
    let site = path[1];
    if(site === 'lipton-us'){
      this.privacyPath = "/lipton-us/en/USD/";
    }else{
      this.privacyPath = "/lipton-pk/en/PKR/contact";
    }
    this.globalMessageService.add(
      '<span>For any modifications, please contact our <a href='+this.privacyPath+'>customer service</a></span>',
      GlobalMessageType.MSG_TYPE_INFO,
      600000
    );
    this.getAddress();
    this.addressId$ = this.userAccount.get();
  }

  getAddress() {

    this.cartService.getTheListOfShippingAddress().subscribe((resp) => {
      this.addressObj = resp?.addresses;
      this.cdf.detectChanges();
    });
  }

  setAsDefault(id: any) {
    this.cartService.setAsDefaultAddress(id).subscribe((res) => {
      this.addressObj.map((obj: any) => {
        obj.id == id
          ? (obj.defaultAddress = true)
          : (obj.defaultAddress = false);
      });
      this.cdf.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
  }
}
